/* Requirements:

Paste this code in your template where this will be used, before loading the script.

{% assign config = shop.metaobjects.json_object["shipping-delays"] %}
<script type="application/json" id="shipping-table">
  {{ config.json | raw }}
</script>

<script>
  window.serverDateTime = '{{ "now" | date: "%Y-%m-%dT%H:%M:%S" }}';
  window.receiveShipment = '{{ "custom.general.receive_shipment" | t }}';

  const shippingData = JSON.parse(document.getElementById('shipping-table').textContent);
</script>

*/

document.addEventListener('DOMContentLoaded', () => {
    async function getLocationData() {
      try {
        // 1. Get the user's public IP address
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        const userIP = ipData.ip;

        // 2. Call your API using the user's IP address
        const apiResponse = await fetch(`https://automation.gopiscine.ca/api/location?ip=${userIP}`, {
          headers: {
            Authorization: 'Bearer vNT1wCdzJd2cy3bShFb4pXqgHKzEaTK1bQgy0t5aAfg'
          }
        });

        // 3. Store the response in a variable
        if (!apiResponse.ok) throw new Error('API error');
        const locationData = await apiResponse.json();

        return locationData;

      } catch (error) {
        console.error('Error fetching location data:', error);
        return null;
      }
    }

    getLocationData().then((locationData) => {
      if (locationData) {
        const deliveryPostal = locationData?.data?.postal?.code;
        const deliveryDate = getDeliveryDate(deliveryPostal);
        const deliveryCity = locationData?.data?.city?.names?.en;

        let el = document.createElement('div');
        let cityEl = document.createElement('p');
        let dateEl = document.createElement('p');

        cityEl.classList.add('city');
        cityEl.innerHTML = `${deliveryPostal} | ${deliveryCity}`;

        dateEl.classList.add('date');
        dateEl.innerHTML = `${window.receiveShipment} <strong>${deliveryDate}</strong>`;

        el.appendChild(cityEl);
        el.appendChild(dateEl);
         
        document.querySelector("*[data-shipping] .pickup_days").replaceWith(el);

        // Shipping countdown
        const timerEl = document.querySelector('[data-shipping-timer]');
        if (timerEl) {
            const cutoffTime = getCutoffDeadline(window.serverDateTime);
            startShippingCountdown(cutoffTime, '[data-shipping-timer]', deliveryDate);
        }
      }
    });
});

function getOrderProcessingStartDate(baseDate, holidays = []) {
    let start = new Date(baseDate); 

    // Bump one day if after 2 PM (cutoff)
    if (start.getHours() >= 14) {
      start.setDate(start.getDate() + 1);
    }

    // Find next non-weekend, non-holiday day
    while (true) {
      const day = start.getDay(); // 0 = Sun, 6 = Sat
      const isoDate = start.toISOString().split('T')[0];
      const isWeekend = day === 0 || day === 6;
      const isHoliday = holidays.includes(isoDate);

      if (!isWeekend && !isHoliday) break;

      start.setDate(start.getDate() + 1);
    }

    return start;
}

function getDeliveryDateFromStart(startDate, shippingDays, skipSaturday, holidays = []) {
    let deliveryDate = new Date(startDate);

    while (shippingDays > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);

      const day = deliveryDate.getDay();
      const isoDate = deliveryDate.toISOString().split('T')[0];

      const isSunday = day === 0;
      const isSaturday = day === 6 && skipSaturday;
      const isHoliday = holidays.includes(isoDate);

      if (!isSunday && !isSaturday && !isHoliday) {
        shippingDays--;
      }
    }

    return deliveryDate;
}

function getDeliveryDate(postalCode) {
    const regionData = shippingData["postal"][postalCode.charAt(0)]["shipping"];
    const holidayList = shippingData.holidays || [];

    const shippingDays = regionData["days"];
    const skipSaturday = regionData["saturday"] === false;

    let now = new Date(window.serverDateTime);
    let originalDate = new Date(now);

    const processingStart = getOrderProcessingStartDate(now, holidayList);
    const deliveryDate = getDeliveryDateFromStart(processingStart, shippingDays, skipSaturday, holidayList);

    const lang = document.documentElement.lang || 'en';
    const msPerDay = 1000 * 60 * 60 * 24;
    const diffInDays = Math.floor((deliveryDate - originalDate) / msPerDay);
    const isTomorrow = diffInDays === 1;

    const prettyDate = formatDatePretty(deliveryDate, lang);
    return isTomorrow
      ? (lang === 'fr' ? `demain – ${prettyDate}` : `Tomorrow – ${prettyDate}`)
      : prettyDate;
}


function formatDatePretty(date, lang = 'en') {
    const weekdays = {
      en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      fr: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
    };

    const months = {
      en: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ],
      fr: [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ]
    };

    const day = date.getDate();
    const monthName = months[lang][date.getMonth()];
    const weekdayName = weekdays[lang][date.getDay()];

    if (lang === 'fr') {
      return `${weekdayName} ${day} ${monthName}`;
    } else {
      const suffix =
        day % 10 === 1 && day !== 11 ? 'st' :
        day % 10 === 2 && day !== 12 ? 'nd' :
        day % 10 === 3 && day !== 13 ? 'rd' : 'th';
      return `${weekdayName} ${monthName} ${day}${suffix}`;
    }
}

  // Shipping timer

function getCutoffDeadline(serverDateTime) {
    let now = new Date(serverDateTime);
    let cutoff = new Date(now);

    cutoff.setHours(14, 0, 0, 0); // 2:00 PM

    // If cutoff has passed today, move to next day
    if (now >= cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    return cutoff;
}

function startShippingCountdown(cutoffTime, elementSelector, deliveryDate) {
    const countdownEl = document.querySelector(elementSelector);

    function updateTimer() {
      const now = new Date();
      const diff = cutoffTime - now;

      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      countdownEl.innerHTML = `<strong>${window.shippingIncentiveTitle}</strong> - ${window.orderWithin} - <strong>${hours}h ${minutes}m ${seconds}s</strong>`;
    }

    updateTimer();
    const timer = setInterval(updateTimer, 1000);
}


  // Util functions

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}